
import { defineComponent } from "vue";
import {DataLayerApi} from "@/services/Api";

export default defineComponent({
  props: {
    basketid: {
      type: String,
      required: true,
    }
  },
  methods: {
  },
  mounted() {
    DataLayerApi.createPurchaseEvent(this.basketid);
  }
});
